export enum PriceRangeCellBlock {
  Root = 'PriceRange',
}
